
/*
 * Implementación de promises.all que invoca a resolve o rejected cuando se cumplieron todas las promesas. (la implementación de angular invoca al rejected ni bien falla una).
 */
var promises = {};

promises.all = function (promesas) {

    var count = 0,
        total = promesas.length,
        resultados = [],
        hasFailed = false,
        deferred = $q.defer();

    function resolved(res, failed, result) {
        res.failed = failed;
        res.result = result;
        hasFailed = hasFailed || failed;

        count++;

        if (count === total) {
            if (hasFailed)
                deferred.reject(resultados);
            else
                deferred.resolve(resultados);
        }
    }

    angular.forEach(promesas, function (p) {
        var res = {};
        resultados.push(res);

        p.then(function ok() {
            resolved(res, false, arguments);
        }, function error() {
            resolved(res, true, arguments);
        });
    });

    return deferred.promise;
};
